import moment from 'moment'
const columns = [
  {
    title: '任务ID',
    key: 'jobId',
    width: 200,
  },
  {
    title: '调度时间',
    key: 'triggerTime',
    width: 200,
    render: (h, params) => {
      let fromIP = params.row.triggerTime;
      let result = moment(fromIP).format('YYYY-MM-DD HH:mm:ss')
      return h("div", result);
    },
  },
  {
    title: '调度结果',
    render: (h, params) => {
      let fromIP = params.row.triggerCode;
      let result = fromIP === 200 ? '成功' : '失败';
      return h("div", result);
    },
  },
  {
    title: '执行时间',
    key: 'handleTime',
    width: 200,
    render: (h, params) => {
      let result = params.row.handleTime || '--'
      return h("div", result);
    },
  },
  {
    title: '执行结果',
    key: 'handleCode',
    width: 200,
    render: (h, params) => {
      let result = params.row.handleCode || '--'
      return h("div", result);
    },
  },
  {
    title: '执行备注',
    key: 'handleMsg',
    width: 200,
    render: (h, params) => {
      let result = params.row.handleMsg || '--'
      return h("div", result);
    },
  },
  {
    title: '操作',
    slot: 'iconfont',
    width: 120,
    iconClass: [
      {name: '查看', code: 'edit', status: 2, type: 'success', size: 'small'},
      {name: '关闭', code: 'edit', status: 2, type: 'success', size: 'small'}
    ]
  },
]

export default columns